import styles from "./styles/PrintableDisbursementStyles";
import LogoHeader from "../../../../components/common/LogoHeader";
import {
  formatCurrency,
  formatNumberToWords,
  formattedRate,
} from "../../../../components/common/Converter";
import { formatMonthPeriodRange } from "../helper/helperFunction";
import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../Payroll/helper-payroll/constants/payrollConstants";

const getValidDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const getPeriodCategoryLabel = ({
  object,
  payrollType,
  payItem,
  payrollItem,
  payrollAmntLists,
}) => {
  const startDate = object?.startDate;
  const endDate = object?.endDate;
  const year = payrollItem?.year ?? object?.year;

  const formatRangeLabel = () => {
    const start = getValidDate(startDate);
    const end = getValidDate(endDate);

    if (start && end) {
      const sameMonth =
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth();

      if (sameMonth) {
        return `${start.toLocaleDateString("en-US", { month: "long" })} ${start.getDate()}-${end.getDate()}, ${start.getFullYear()}`;
      }

      const startLabel = start.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        ...(start.getFullYear() !== end.getFullYear() && { year: "numeric" }),
      });
      const endLabel = end.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });

      return `${startLabel} - ${endLabel}`;
    }

    if (start) {
      return start.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
      });
    }

    if (startDate && endDate && year) {
      return formatMonthPeriodRange(startDate, endDate, year);
    }

    if (startDate && endDate) {
      return `${startDate} - ${endDate}`;
    }

    return startDate || endDate || "";
  };

  if (
    !isAddendumBackPayItem(payItem) &&
    payItem !== "20% Monthly Premium" &&
    payrollType !== "Individual Payroll"
  ) {
    return formatRangeLabel();
  }

  if (payrollType === "Individual Payroll" || payrollType === "Augmentation Pay") {
    return formatRangeLabel();
  }

  if (payItem === "20% Monthly Premium") {
    return formatMonthPeriodRange(startDate, endDate, year);
  }

  return payrollAmntLists?.backpayDate ?? "";
};

export default function PrintableDisbursmentVoucher({
  object,
  payrollData,
  backPayData,
  attachmentsList,
  payrollAmntLists,
  backPay,
  otherData,
}) {
  console.log("payrollAmntLists", payrollAmntLists)
  console.log("object", object);
  const { payrollType, payItem, jobType } = object;
  const { signatories, actualData } = otherData;

  const actualPayrollData = actualData?.[0] ;

  console.log("payrollData", payrollData);
  console.log("actualPayrollData", actualPayrollData);

  const isJOBackPay =
    jobType === "Job Order" && isBackPayItem(payItem);
  const isnoJoBackPay =
    jobType === "Job Order" && isBackPayItem(payItem);
  const isApBackpay =
    payrollType === "Augmentation Pay" && isBackPayItem(payItem);

  const listOfEmployee = isJOBackPay
    ? backPay
    : isApBackpay
    ? backPay
    : isnoJoBackPay
    ? payrollData
    : !isAddendumBackPayItem(payItem)
    ? payrollData
    : backPay;

  const isJOInitialLast =
    jobType === "Job Order" &&
    (payItem === "Initial Salary" || payItem === "Last Salary");
  const isCertificationShow =
    payItem === "Initial Salary(AP)" || payItem === "Last Salary(AP)";
  const isInitialLastAp =
    payItem === "Initial Salary(AP)" || payItem === "Last Salary(AP)";

    const joPayroll = jobType === "Job Order";
    const personnelLabel = joPayroll ? "Job Order Personnel" : "Official/s & Employee/s";
  // const isLastJo = jobType === "Job Order" && payItem === "Last Salary";
  // const isNotAddendumBP =
  //   payrollType === "Basic Pay" && payItem !== "Addendum Payroll";
  const isBasicJo = payrollType === "Basic Pay" && jobType === "Job Order";
  const isSpecialJo = payrollType === "Special Payroll" && jobType === "Job Order";

  const isSalaryDiff = payItem === "Salary Differential (Basic)";
  const { dynamicLabel, contributionLists } = payrollAmntLists;
  const payrollItem = payrollData?.[0];
  const backPayItem = backPayData?.[0];

  const joPosition = actualPayrollData?.employee?.nonRegPosition ?? "";
  const joPositionTitle = joPosition.positionTitle ? `${joPosition.positionTitle} (JOB ORDER)` : "";

  const periodCategory = getPeriodCategoryLabel({
    object,
    payrollType,
    payItem,
    payrollItem,
    payrollAmntLists,
  });

  const midYearAmt =
    payrollAmntLists?.otherPayrollData?.["Mid Year Differential"] || 0;
  const yearEndAmt =
    payrollAmntLists?.otherPayrollData?.["Year End Differential"] || 0;

  return (
    <>
      <div style={{ padding: "10px" }}>
        <div style={styles.mainContainer}>
          <div style={styles.contentContainer}>
            <div style={styles.logoSection}>
              <LogoHeader
                logoSrc={"/BIR.png"}
                rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
                altText="Print Logo"
                mainLabel="Republic Of the Philippines"
                subLabel="BUREAU OF IMMIGRATION"
                description="MANILA"
                styles={styles.logoStyles}
              />
              <h5 style={styles.disbursementLbl}>DISBURSEMENT VOUCHER</h5>
            </div>
            <div style={styles.metaInfoSection1}>
              <div style={{ ...styles.label, ...styles.sec1Lbl }}>
                Fund Cluster
              </div>
              <div
                style={{
                  ...styles.label,
                  ...styles.dateLbl,
                  ...styles.sec1Lbl,
                }}
              >
                Date:
              </div>
              <div style={{ ...styles.label, ...styles.sec1Lbl }}>
                DV No.:
                <p style={{ textAlign: "center" }}>{object?.dvNumber ?? ""}</p>
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection2}>
            <div style={styles.modeOfPayment}>Mode of Payment</div>
            <div style={styles.checkboxSection}>
              <div>
                <input type="checkbox" />
                <label>MDS Check</label>
              </div>
              <div>
                <input type="checkbox" />
                <label>Commercial Check</label>
              </div>
              <div>
                <input type="checkbox" />
                <label>ADA</label>
              </div>
              <div>
                <input type="checkbox" />
                <label>Other Please Specify</label>
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection2}>
            <div style={styles.payeeDetailsSec1}>
              <div style={styles.payeeSec}>Payee</div>
              <div style={styles.addressSec}>Address</div>
            </div>
            <div style={styles.payeeDetailsSec2}>
              <div style={styles.employeeSec1}>
                <div style={styles.employeeNameSec}>
                  <p
                    style={{
                      ...styles.label,
                      ...(styles.joPayeeStyles),
                    }}
                  >
                    {dynamicLabel?.payeeLbl}
                  </p>
                </div>
                <div style={styles.tinSec}>TIN/Employee No.</div>
              </div>
              <div style={styles.employeeSec2}>
                <div style={styles.accountNumSec}>
                  <h2
                    style={{
                      ...styles.label,
                      ...( styles.joAddressStyles),
                    }}
                  >
                    {dynamicLabel?.addressLbl}
                  </h2>
                </div>
                <div style={styles.tinSec}>ORS/BURS No.</div>
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection3}>
            <div style={styles.headersRowLbl}>
              <div style={styles.particularsLbl}>Particulars</div>
              <div style={styles.responsibilityLbl}>Responsibility Center</div>
              <div style={styles.mofLbl}>MFO/PAP</div>
              <div style={styles.amountLbl}>Amount</div>
            </div>
          </div>
          <div style={styles.metaInfoSection4}>
            <div style={styles.headersRowLbl}>
              <div style={styles.particularsContent}>
                <div style={styles.particularsSubContent}>
                  <div>
                    {dynamicLabel?.payrollCodeLbl}
                    {""}
                    <b>{dynamicLabel?.payrollCodeName}</b>
                  </div>
                  <div>{(object?.jobType ?? "").toUpperCase()}</div>
                  <div style={styles.spanContainer}>
                    {isJOInitialLast && <span>1.</span>}
                    <span>{dynamicLabel?.paymentLbl}</span>
                    <span> for:</span>
                    <span style={styles.spanBlankSec}>
                      {dynamicLabel?.salaryTypeLbl}
                    </span>
                    {payItem === "Salary Differential (Basic)" ? (
                      <>
                        <span>from</span>
                        <span style={styles.spanBlankSec}>
                          {payrollData[0]?.oldPositionTitle ?? ""}
                        </span>
                        <span>@</span>
                        <span style={styles.spanBlankSec}>
                          {payrollData[0]?.oldSalaryGrade ?? ""}
                        </span>
                        <span>to</span>
                        <span style={styles.spanBlankSec}>
                          {payrollData[0]?.employee?.position?.position_title ??
                            ""}
                        </span>
                        <span>@</span>
                        <span style={styles.spanBlankSec}>
                          {payrollData[0]?.oldRate ?? ""}
                        </span>
                        <span> for the period of</span>
                        <span style={styles.spanBlankSec}>
                          {object?.startDate ?? ""} - {object?.endDate ?? ""}
                        </span>

                        {midYearAmt !== 0 && (
                          <div style={{ marginTop: "10px" }}>
                            <i
                              className="bi bi-caret-right-fill"
                              style={{ marginRight: "5px" }}
                            ></i>
                            Midyear Differential
                          </div>
                        )}

                        {yearEndAmt !== 0 && (
                          <div>
                            <i
                              className="bi bi-caret-right-fill"
                              style={{ marginRight: "5px" }}
                            ></i>
                            Yearend Differential
                          </div>
                        )}

                        {}
                      </>
                    ) : payrollType !== "Individual Payroll" ? (
                      <>
                        <span>of</span>
                        <span style={styles.spanBlankSec}>
                          {listOfEmployee?.length ?? 0}
                        </span>
                        <span>
                          <b>
                            <span>
                              {payItem === "Newly-Hired" && "Newly Hired"}
                            </span>{" "}
                            <span>{personnelLabel}</span>
                          </b>
                        </span>{" "}
                        <span>of this Bureau for the period</span>
                        <span style={styles.spanBlankSec}>
                          {periodCategory}
                        </span>
                      </>
                    ) : payItem === "Initial RATA" ? (
                      <>
                        <span>as</span>
                        <span style={styles.spanBlankSec}>
                          {dynamicLabel?.positionLbl}
                        </span>
                        <span>of this Bureau for the period of</span>
                        <span style={styles.spanBlankSec}>
                          {periodCategory}
                        </span>
                      </>
                    ) : (
                      <>
                        <span>for the period of</span>
                        <span style={styles.spanBlankSec}>
                          {periodCategory}
                        </span>
                        <span>as</span>
                        <span style={styles.spanBlankSec}>
                          {dynamicLabel?.positionLbl}
                        </span>
                        <span>of this Bureau</span>{" "}
                        <>
                          {payItem !== "Initial Salary(AP)" &&
                            payItem !== "Last Salary(AP)" && (
                              <>
                                <span>rate:</span>
                                <span style={styles.spanBlankSec}>
                                  {formatCurrency(
                                    (dynamicLabel?.salaryLbl ?? 0).toString()
                                  )}
                                </span>
                                <span>/month</span>
                                <br></br>
                                <br></br>
                              </>
                            )}
                        </>
                      </>
                    )}
                    {(payrollType === "Augmentation Pay" ||
                      isInitialLastAp || isBasicJo || isSpecialJo) && <p>*Express Lane Fund</p>}
                    {(isJOInitialLast) && (
                      <>
                        <span>2.</span>
                        <span>Payment for the 20% Monthly Premium for</span>
                        <span style={styles.spanBlankSec}>
                          {periodCategory}
                        </span>
                        <p></p>
                       {otherData?.actualData?.[0]?.gratuityPay && (
                        <>
                        <span>3.</span>
                        <span>Payment for the Gratuity Pay for</span>
                        <span style={styles.spanBlankSec}>
                          {periodCategory}
                        </span>
                        </>
                       )}
                       <p>*Express Lane Fund</p>
                      </>
                    )}
                  </div>
                  <div style={styles.attachContainer}>
                    <div style={styles.sec_1}>
                      <div style={styles.attachmentSec}>ATTACHMENTS:</div>
                      <div style={styles.attachmentList}>
                        {attachmentsList?.length > 0 ? (
                          attachmentsList.map((item, index) => (
                            <div key={index} style={styles.attachmentItems}>
                              {index + 1}. {item}
                            </div>
                          ))
                        ) : (
                          <div style={styles.attachmentItems}>
                            No attachments
                          </div>
                        )}
                      </div>
                    </div>
                    {(isCertificationShow || isJOInitialLast) && (
                      <div style={styles.sec_2}>
                        <p style={styles.certificationLbl}>CERTIFICATION</p>
                        <p style={styles.label}>
                          This is to certify that I am willing to refund this
                          claim if found not in order{" "}
                        </p>
                        <div style={styles.payeeDiv}>
                          {dynamicLabel?.payeeLbl}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div style={styles.responsibilityLbl}></div>
              <div style={styles.mofLbl}></div>
              <div style={styles.amountLbl}>
                <p>
                  {formatCurrency(
                    (payrollAmntLists?.netPayTotal ?? 0).toString()
                  )}
                </p>
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection5}>
            <div style={styles.certifiedRow}>
              <button style={styles.buttonSec}>A.</button>
              <span style={styles.certifiedLbl}>
                Certified: Expenses/Cash Advance necessary, lawful and incurred
                under my direct supervision
              </span>
            </div>
            <div style={styles.signatureSec}>
              Printed Name, Designation and Signature of Supervisor
            </div>
          </div>
          <div style={styles.metaInfoSection6}>
            <div>
              <button style={styles.buttonSec}>B.</button>
              <span style={styles.certifiedLbl}>Accounting Entry:</span>
              <table style={styles.tableContainer}>
                <thead style={styles.theadSec}>
                  <tr>
                    <th style={styles.accountTitleLbl}>Account Title</th>
                    <th style={styles.uascsLbl}>UACS Code</th>
                    <th style={styles.debitLbl}>Debit</th>
                    <th style={styles.creditLbl}>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let rowIndex = 0;
                    const isAP = payrollType === "Augmentation Pay";

                    if (
                      payrollType === "Special Payroll" &&
                      payItem !== "20% Monthly Premium" &&
                      payrollAmntLists?.categorized
                    ) {
                      const { debit = [], credit = [] } =
                        payrollAmntLists.categorized;

                      const renderRow = (acc, type) => (
                        <tr
                          key={`${type}-${acc.id}`}
                          style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                        >
                          <td style={styles.accountTitleLbl}>{acc.name}</td>
                          <td style={styles.uascsLbl}>{acc.uacsCode}</td>
                          <td style={styles.debitLbl}>
                            {type === "debit" && acc.amount !== 0
                              ? formatCurrency(acc.amount.toString())
                              : ""}
                          </td>
                          <td style={styles.creditLbl}>
                            {type === "credit" && acc.amount !== 0
                              ? formatCurrency(acc.amount.toString())
                              : ""}
                          </td>
                        </tr>
                      );

                      const categorizedRows = [...debit, ...credit].map(
                        (acc) => {
                          const type = debit.includes(acc) ? "debit" : "credit";
                          const row = renderRow(acc, type);
                          rowIndex++;
                          return row;
                        }
                      );

                      // Add the "Cash" credit row based on netTotal
                      const netTotal =
                        payrollAmntLists?.cashTotal?.netTotal || 0;
                      const cashRow = (
                        <tr
                          key="cash-row"
                          style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                        >
                          <td style={styles.accountTitleLbl}>Cash</td>
                          <td style={styles.uascsLbl}>1-01-04-040</td>
                          <td style={styles.debitLbl}></td>
                          <td style={styles.creditLbl}>
                            {netTotal !== 0 ? (
                              <b>{formatCurrency(netTotal.toString())}</b>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      );
                      rowIndex++;

                      return [...categorizedRows, cashRow];
                    }

                    let accountRows = [
                      { title: "Salaries and Wages", code: "5-01-01-010" },
                      {
                        title: "Personal Economic Relief Allowance(PERA)",
                        code: "5-01-02-010",
                      },
                      { title: "Due to BIR", code: "2-02-01-010" },
                      { title: "Due to GSIS", code: "2-02-01-020" },
                      { title: "Due to Philhealth", code: "2-02-01-040" },
                      { title: "Due to Pagibig", code: "2-02-01-030" },
                      { title: "Cash", code: "1-01-04-040", id: "_cash" },
                    ];
                    if (payItem === "Initial Salary(AP)") {
                      accountRows = [
                        {
                          title: "Due to Officers and Employees",
                          code: "2-04-01-010",
                          id: "_due_to_offiicer",
                        },
                        {
                          title: "Due to BIR",
                          code: "2-02-01-010",
                        },
                        { title: "Cash", code: "1-01-02-020-24", id: "_cash" },
                      ];
                    } else if (payItem === "Last Salary(AP)") {
                      accountRows = [
                        {
                          title: "Due to Officers and Employees",
                          code: "2-04-01-010",
                          id: "_due_to_offiicer",
                        },
                        { title: "Due to BIR", code: "2-02-01-010" },
                        { title: "titleAccLists", code: "titleAccLists" },
                        { title: "Cash", code: "1-01-02-020-24", id: "_cash" },
                      ];
                    } else if (isJOInitialLast) {
                      accountRows = [
                        {
                          title: "Trust Liabilities",
                          code: "2-04-01-010",
                        },
                        {
                          title: "Gratuity Pay",
                          code: "2-04-01-010",
                        },
                        {
                          title: "Due to BIR (3%)",
                          code: "2-02-01-010",
                          id: "_due",
                        },
                        { title: "titleAccLists", code: "titleAccLists" },
                        { title: "Cash", code: "1-01-02-020-24", id: "_cash" },
                      ];
                    } else if (payItem === "Initial RATA") {
                      accountRows = [
                        {
                          title:
                            "Representation Allowance/Transportation Allowance",
                          code: "5-01-01-020",
                        },
                        { title: "Cash", code: "1-01-04-040" },
                      ];
                    } else if (payItem === "20% Monthly Premium") {
                      accountRows = [
                        {
                          title: "Due to BIR (3%)",
                          code: "2-02-01-010",
                          id: "_due",
                        },
                        { title: "Cash", code: "1-01-02-020-24", id: "_cash" },
                      ];

                      accountRows.unshift({
                        title: "Trust Liabilities",
                        code: "2-04-01-010",
                      });
                    } else if (isAP) {
                      accountRows = accountRows.filter((item) =>
                        ["2-02-01-010", "1-01-04-040"].includes(item.code)
                      );

                      accountRows.unshift({
                        title: "Trust Liabilities",
                        code: "2-04-01-010",
                      });
                    } else if (isSalaryDiff) { 
                      accountRows = [
                        { title: "Salaries and Wages", code: "5-01-01-010" },
                        ...(midYearAmt !== 0
                          ? [
                              {
                                title: "Mid Year Differential",
                                code: "5-01-02-140",
                              },
                            ]
                          : []),
                        ...(yearEndAmt !== 0
                          ? [
                              {
                                title: "Year End Differential",
                                code: "5-01-02-140",
                              },
                            ]
                          : []),
                        { title: "Due to GSIS", code: "2-02-01-020" },
                        { title: "Due to Philhealth", code: "2-02-01-040" },
                        { title: "Due to BIR", code: "2-02-01-010" },
                        { title: "Cash", code: "1-01-04-040", id: "_cash" },
                      ];
                    }else if(joPayroll) {
                      accountRows = [
                        {
                          title: "Trust Liabilities",
                          code: "2-04-01-010",
                        },
                        { title: "Due to BIR", code: "2-02-01-010" },
                        { title: "titleAccLists", code: "titleAccLists" },
                        { title: "Cash", code: "1-01-02-020-24", id: "_cash" },
                      ];
                    }

                    return accountRows.flatMap((item) => {
                      const rows = [];
                      const contributionAmount =
                        payrollAmntLists?.contributionLists?.[item.title] || 0;
                      const amount =
                        payrollAmntLists?.contributionLists?.["Due to BIR"] ||
                        0;

                      const debitAmount =
                        payrollAmntLists?.otherPayrollData?.[item.title] || 0;
                      const dueToOfficers =
                        payrollAmntLists?.otherPayrollData?.[
                          "Trust Liabilities"
                        ] || 0;
                      const salariesWages =
                        payrollAmntLists?.otherPayrollData?.[
                          "Salaries and Wages"
                        ] || 0;

                      if (
                        item.code === "titleAccLists" &&
                        (payItem === "Last Salary(AP)" ||
                          (payrollType === "Basic Pay" &&
                            jobType === "Job Order") ||
                          isJOInitialLast) &&
                        Array.isArray(payrollAmntLists?.titleAccLists)
                      ) {
                        rows.push(
                          ...payrollAmntLists.titleAccLists.map((acc) => {
                            const row = (
                              <tr
                                key={`acc-${acc.id}`}
                                style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                              >
                                <td style={styles.accountTitleLbl}>
                                  {acc.name}
                                </td>
                                <td style={styles.uascsLbl}>{acc.uacsCode}</td>
                                <td style={styles.debitLbl}></td>
                                <td style={styles.creditLbl}>
                                  {acc.amount === 0
                                    ? ""
                                    : formatCurrency(acc.amount.toString())}
                                </td>
                              </tr>
                            );
                            rowIndex++;
                            return row;
                          })
                        );
                        return rows;
                      }

                      rows.push(
                        <tr
                          key={`main-${rowIndex}`}
                          style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                        >
                          <td style={styles.accountTitleLbl}>{item.title}</td>
                          <td style={styles.uascsLbl}>{item.code}</td>
                          <td style={styles.debitLbl}>
                            {item.id === "_due_to_offiicer" &&
                              formatCurrency(dueToOfficers.toString())}
                            {debitAmount === 0
                              ? ""
                              : formatCurrency(debitAmount.toString())}
                          </td>
                          <td style={styles.creditLbl}>
                            {item.id === "_due" &&
                              formatCurrency(amount.toString())}
                            {item.id === "_cash" ? (
                              <b>
                                {(payrollAmntLists?.cashTotal?.netTotal ||
                                  0) === 0
                                  ? ""
                                  : formatCurrency(
                                      payrollAmntLists.cashTotal.netTotal.toString()
                                    )}
                              </b>
                            ) : contributionAmount === 0 ? (
                              ""
                            ) : (
                              formatCurrency(contributionAmount.toString())
                            )}
                          </td>
                        </tr>
                      );
                      rowIndex++;

                      // Only render titleAccLists once, after Trust and Liabilities row
                      if (
                        isAP &&
                        item.code === "2-02-01-010" &&
                        Array.isArray(payrollAmntLists?.titleAccLists)
                      ) {
                        rows.push(
                          ...payrollAmntLists.titleAccLists.map((acc) => {
                            const row = (
                              <tr
                                key={`acc-${acc.id}`}
                                style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                              >
                                <td style={styles.accountTitleLbl}>
                                  {acc.name}
                                </td>
                                <td style={styles.uascsLbl}>{acc.uacsCode}</td>
                                <td style={styles.debitLbl}></td>
                                <td style={styles.creditLbl}>
                                  {acc.amount === 0
                                    ? ""
                                    : formatCurrency(acc.amount.toString())}
                                </td>
                              </tr>
                            );
                            rowIndex++;
                            return row;
                          })
                        );
                      }

                      // Original behavior: show titleAccLists after Pagibig if not AP
                      if (
                        !isAP &&
                        item.code === "2-02-01-030" &&
                        Array.isArray(payrollAmntLists?.titleAccLists)
                      ) {
                        rows.push(
                          ...payrollAmntLists.titleAccLists.map((acc) => {
                            const row = (
                              <tr
                                key={`acc-${acc.id}`}
                                style={rowIndex % 2 === 1 ? styles.evenRow : {}}
                              >
                                <td style={styles.accountTitleLbl}>
                                  {acc.name}
                                </td>
                                <td style={styles.uascsLbl}>{acc.uacsCode}</td>
                                <td style={styles.debitLbl}></td>
                                <td style={styles.creditLbl}>
                                  {acc.amount === 0
                                    ? ""
                                    : formatCurrency(acc.amount.toString())}
                                </td>
                              </tr>
                            );
                            rowIndex++;
                            return row;
                          })
                        );
                      }

                      return rows;
                    });
                  })()}
                </tbody>
              </table>
            </div>
          </div>
          <div style={styles.metaInfoSection7}>
            <div style={styles.certifiedSec}>
              <button style={styles.buttonSec}>C.</button>
              <span style={styles.certifiedLbl}>Certified:</span>
              <div style={styles.checkboxContainer}>
                <div>
                  <input type="checkbox" />
                  <span>Cash Available</span>
                </div>
                <div>
                  <input type="checkbox" />
                  <span>
                    Subject to Authority to Debit Account (when applicable)
                  </span>
                </div>
                <div>
                  <input type="checkbox" />
                  <span>Supporting documents complete and amount claimed proper</span>
                </div>
              </div>
            </div>
            <div style={styles.certifiedSec}>
              <button style={styles.buttonSec}>D.</button>
              <span style={styles.certifiedLbl}>Approved for Payment:</span>
              <div style={styles.amountHolderSec}>
                {formatNumberToWords(payrollAmntLists?.netPayTotal ?? 0)}
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection8}>
            <div style={styles.signatureSec1}>
              <div style={styles.signBlockContainer}>
                <div>Signature</div>
                <div>Printed Name</div>
                <div>Position</div>
              </div>
              <div style={styles.authorizedPersonnelSec}>
                <div>
                  <b>{signatories?.firstName}</b>
                </div>
                <div>{signatories?.firstPosition}</div>
                <div>Head Accounting Unit/Authorized Representative</div>
              </div>
            </div>
            <div style={styles.signatureSec2}>
              <div style={styles.signBlockContainer}>
                <div>Signature</div>
                <div>Printed Name</div>
                <div>Position</div>
              </div>
              <div style={styles.authorizedPersonnelSec}>
                <div>
                  <b>{signatories?.secondName}</b>
                </div>
                <div>{signatories?.secondPosition}</div>
                <div>Agency Head/Authorized Representative</div>
              </div>
            </div>
          </div>
          <div style={styles.metaInfoSection9}>
            <div style={styles.dateBlock1}>Date:</div>
            <div style={styles.dateBlock2}>Date:</div>
          </div>
          <div style={styles.metaInfoSection10}>
            <div style={styles.recipientSec}>
              <button style={styles.buttonSec}>E.</button>
              <span style={styles.certifiedLbl}>Receipt of Payment:</span>
              <div style={styles.adaSec}>
                <div style={styles.checkSec}>Check/ADA No:</div>
                <div style={styles.blankSec}></div>
                <div style={styles.dateSec}>Date:</div>
                <div style={styles.bankNameSec}>
                  Bank Name & Account Number:
                </div>
              </div>
              <div style={styles.adaSec}>
                <div style={styles.checkSec}>Signature:</div>
                <div style={styles.blankSec}></div>
                <div style={styles.dateSec}>Date:</div>
                <div style={styles.bankNameSec}>Printed Name:</div>
              </div>
              <div style={styles.adaSec}>
                <div style={styles.officialSec}>
                  Official Receipt No. & Date/Other Documents
                </div>
              </div>
            </div>
            <div style={styles.jevSec}>
              <div style={styles.jevLbl}>JEV No.</div>
              <div style={styles.jevDateLbl}>Date</div>
            </div>
          </div>
        </div>
      </div>
      {jobType !== "Job Order" &&
      (payItem === "Initial Salary" ||
        payItem === "Last Salary" ||
        isSalaryDiff) ? (
        <div style={styles.computationSection}>
          <div style={styles.metaInfoSection11}>
            <div>
              <b>{dynamicLabel?.payeeLbl}</b>
            </div>
            {isSalaryDiff && (
              <>
                <div>SAL. DIFFERENTIAL COMPUTATION</div>
                <div style={{ marginTop: "10px", display: "flex" }}>
                  <div>OLD BASIC RATE</div>
                  <div style={{ marginLeft: "20px" }}>
                    <b>{payrollData[0]?.oldSalaryGrade ?? ""}</b>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div>NEW BASIC RATE</div>
                  <div style={{ marginLeft: "20px" }}>
                    <b>{payrollData[0]?.oldRate ?? ""}</b>
                  </div>
                </div>
              </>
            )}
            <div>{dynamicLabel?.payComputationLbl}</div>

            {!isSalaryDiff && (
              <>
                <div style={{ ...styles.firstSecDiv }}>
                  <div
                    style={{
                      ...styles.divSecStyles1,
                      ...styles.hasMargin,
                    }}
                  >
                    <div style={styles.childEqualWidth}>
                      GROSS BASIC (PRO RATED)
                    </div>
                    <div style={styles.childEqualWidth}>
                      {formatCurrency(
                        (dynamicLabel?.proratedBasic ?? 0).toString()
                      )}
                    </div>
                    <div style={styles.childEqualWidth}></div>
                  </div>
                  <div style={{ ...styles.divSecStyles1 }}>
                    <div style={styles.childEqualWidth}>ABSENCES/LATE/UT</div>
                    <div style={styles.childEqualWidth}>
                      {dynamicLabel?.basic ?? 0}
                    </div>
                    <div style={styles.childEqualWidth}>
                      {formatCurrency(
                        (dynamicLabel?.netProratedBasic ?? 0).toString()
                      )}
                    </div>
                  </div>
                </div>

                <div style={{ ...styles.firstSecDiv }}>
                  <div
                    style={{
                      ...styles.divSecStyles1,
                      ...styles.hasMargin,
                    }}
                  >
                    <div style={styles.childEqualWidth}>
                      PERA/ADA (PRO RATED)
                    </div>
                    <div style={styles.childEqualWidth}>
                      {formatCurrency(
                        (dynamicLabel?.proratedPera ?? 0).toString()
                      )}
                    </div>
                    <div style={styles.childEqualWidth}>
                      {formatCurrency(
                        (dynamicLabel?.netProratedPera ?? 0).toString()
                      )}
                    </div>
                  </div>
                  <div style={{ ...styles.divSecStyles1 }}>
                    <div style={styles.childEqualWidth}>ABSENCES/LATE/UT</div>
                    <div style={styles.childEqualWidth}>
                      {dynamicLabel?.pera ?? 0}
                    </div>
                    <div style={styles.childEqualWidth}></div>
                  </div>
                </div>
              </>
            )}

            <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
              <div>
                <h2 style={styles.label}>TOTAL AMT EARNED</h2>
              </div>
              <div style={styles.totalAmntEarned}>
                {formatCurrency(
                  (dynamicLabel?.totalAmntEarned ?? 0).toString()
                )}
              </div>
            </div>

            <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
              <div>MANDATORY DEDUCTIONS:</div>
            </div>
            <div style={{ ...styles.divSecStyles1 }}>
              <div>TAX</div>
              <div style={styles.totalAmnt}>
                {contributionLists?.["Due to BIR"]}
              </div>
            </div>
            <div style={{ ...styles.divSecStyles1 }}>
              <div>GSIS</div>
              <div style={styles.totalAmnt}>
                {contributionLists?.["Due to GSIS"]}
              </div>
            </div>
            <div style={{ ...styles.divSecStyles1 }}>
              <div>PHILHEALTH</div>
              <div style={styles.totalAmnt}>
                {contributionLists?.["Due to Philhealth"]}
              </div>
            </div>
            {!isSalaryDiff && (
              <div style={{ ...styles.divSecStyles1 }}>
                <div>PAGIBIG</div>
                <div style={styles.totalAmnt}>
                  {formatCurrency(
                    (contributionLists?.["Due to Pagibig"] ?? 0).toString()
                  )}
                </div>
              </div>
            )}

            <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
              <div>
                <h2 style={styles.label}>NET PAY</h2>
              </div>
              <div style={styles.totalAmntEarned}>
                <b>{formatCurrency((dynamicLabel?.netPay ?? 0).toString())}</b>
              </div>
            </div>

            {isSalaryDiff && (
              <>
                <div style={{ ...styles.divSecStyles1 }}>
                  <div>MIDYEAR DIFFERENTIAL</div>
                  <div style={styles.totalAmnt}>{dynamicLabel?.myDiff}</div>
                </div>
                <div style={{ ...styles.divSecStyles1 }}>
                  <div>YEAREND DIFFERENTIAL</div>
                  <div style={styles.totalAmnt}>{dynamicLabel?.yeDiff}</div>
                </div>

                <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
                  <div>
                    <h2 style={styles.label}></h2>
                  </div>
                  <div style={styles.totalAmntEarned}>
                    <b>
                      {formatCurrency(
                        (dynamicLabel?.withYeAndMyDiff ?? 0).toString()
                      )}
                    </b>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ) : payItem === "Initial Salary(AP)" || payItem === "Last Salary(AP)" ? (
        <>
          <div style={styles.computationSection}>
            <div style={styles.metaInfoSection11}>
              <div>
                <b>{dynamicLabel?.payeeLbl}</b>
              </div>
              <div>{dynamicLabel?.payComputationLbl}</div>

              <div style={{ ...styles.firstSecDiv }}>
                <div
                  style={{
                    ...styles.divSecStyles1,
                    ...styles.hasMargin,
                  }}
                >
                  <div style={styles.childEqualWidth}>
                    AUGMENTATION PAY RATE
                  </div>
                  <div style={styles.childEqualWidth}>
                    {formatCurrency(
                      (backPayItem?.employee?.payCode ?? 0).toString()
                    )}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.firstSecDiv }}>
                <div
                  style={{
                    ...styles.divSecStyles1,
                    ...styles.hasMargin,
                  }}
                >
                  <div style={styles.childEqualWidth}>DAYS EARNED</div>
                  <div style={styles.childEqualWidth}>
                    {dynamicLabel?.daysEarned ?? 0}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.firstSecDiv }}>
                <div
                  style={{
                    ...styles.divSecStyles1,
                    ...styles.hasMargin,
                  }}
                >
                  <div style={styles.childEqualWidth}>LATES INCURRED</div>
                  <div style={styles.childEqualWidth}>
                    {dynamicLabel?.latesIncurred ?? 0}
                  </div>
                </div>

                <div style={{ ...styles.divSecStyles1 }}>
                  <div style={styles.childEqualWidth}>OVERPAYMENT</div>
                  <div style={styles.childEqualWidth}>
                    {formatCurrency(
                      (dynamicLabel?.overpayment ?? 0).toString()
                    )}
                  </div>
                </div>
                <div style={{ ...styles.divSecStyles1 }}>
                  <div style={styles.childEqualWidth}>FLAG RAISING</div>
                  <div style={styles.childEqualWidth}>
                    {formatCurrency(
                      (dynamicLabel?.flagRaising ?? 0).toString()
                    )}
                  </div>
                </div>
              </div>

              <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
                <div>
                  <h2 style={styles.label}>AMOUNT EARNED</h2>
                </div>
                <div style={styles.totalAmntEarned}>
                  {formatCurrency(
                    (dynamicLabel?.totalAmntEarned ?? 0).toString()
                  )}
                </div>
              </div>

              <div style={{ ...styles.divSecStyles1 }}>
                <div>TAX</div>
                <div style={styles.totalAmnt}>
                  {formatCurrency(
                    (contributionLists?.["Due to BIR"] ?? 0).toString()
                  )}
                </div>
              </div>

              <div style={{ ...styles.divSecStyles1, ...styles.hasMargin }}>
                <div>
                  <h2 style={styles.label}>NET PAY</h2>
                </div>
                <div style={styles.totalAmntEarned}>
                  <b>
                    {formatCurrency((dynamicLabel?.netPay ?? 0).toString())}
                  </b>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : jobType === "Job Order" && (payItem === "Initial Salary" || payItem === "Last Salary") ? (
        (() => {
          const earned = formatCurrency((actualPayrollData?.earned ?? 0).toString());
          const salaryRate = formatCurrency((joPosition?.montlhyRate ?? 0).toString());
          const latesUt = formatCurrency(
            (
              (payItem === "Last Salary"
                ? actualPayrollData?.absMins
                : actualPayrollData?.absencesMins) ?? 0
            ).toString()
          );
          const monthlyPremium = formatCurrency((actualPayrollData?.twentyPercent ?? 0).toString());
          const gratuityPay = formatCurrency((actualPayrollData?.gratuityPay ?? 0).toString());
          const totalEarned = formatCurrency((actualPayrollData?.totalEarned ?? 0).toString());
          const taxDeducted = formatCurrency((actualPayrollData?.tax ?? 0).toString());
          const netAmtAfterTax = formatCurrency((actualPayrollData?.netAmount ?? 0).toString());
          const totalAmtDue = netAmtAfterTax;

          const { isGraduated } = actualPayrollData?.employee ?? {};
          const educationDegree = otherData?.bachelorsDegree?.educationDegree ?? "";
          const civilCareer = otherData?.serviceEligibility?.civilCareer ?? "";

          const taxOptionLabel = 
                !isGraduated 
                ? ""
                : isGraduated === "YES"
                ? "Graduated"
                : "8%";

          return (
            <div style={styles.computationSection}>
              <div style={styles.metaInfoSection11}>
                <div>
                  <b>{dynamicLabel?.payeeLbl}</b>
                </div>
                <div>{dynamicLabel?.payComputationLbl}</div>
                <div>{joPositionTitle}</div>
                <div>{otherData?.hierarchyItem?.name ?? ""}</div>
                <div>
                  {educationDegree}
                  {civilCareer && ` (${civilCareer})`}
                </div>
                <div>{taxOptionLabel}</div>


                <div style={{ marginTop: "24px", width: "100%" }}>
                  <div style={{ ...styles.divSecStyles1, fontStyle: "normal" }}>
                    <div style={styles.childEqualWidth}>PERIOD</div>
                    <div style={styles.childEqualWidth}>SALARY RATE</div>
                    <div style={styles.childEqualWidth}>DAYS EARNED</div>
                    <div style={styles.childEqualWidth}>LATES/UT</div>
                  </div>
                  <div
                    style={{
                      ...styles.divSecStyles1,
                      fontStyle: "normal",
                      marginTop: "8px",
                    }}
                  >
                    <div style={styles.childEqualWidth}>{periodCategory}</div>
                    <div style={styles.childEqualWidth}>
                      {salaryRate}
                    </div>
                    <div style={styles.childEqualWidth}>
                      {earned}
                    </div>
                    <div style={styles.childEqualWidth}>
                      {latesUt}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: "48px",
                    width: "55%",
                    marginLeft: "auto",
                    fontSize: "12px",
                    fontFamily: "sans-serif",
                  }}
                >
                  {[
                    ["EARNED AMOUNT", earned],
                    ["20% MONTHLY PREMIUM", monthlyPremium],
                    ["GRATUITY PAY", gratuityPay],
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "2px 0",
                      }}
                    >
                      <span>{label}</span>
                      <span>{formatCurrency(value.toString())}</span>
                    </div>
                  ))}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2px 0",
                      borderTop: "1px solid black",
                      marginTop: "4px",
                    }}
                  >
                    <span>TOTAL EARNED</span>
                    <span>{formatCurrency(totalEarned.toString())}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2px 0",
                    }}
                  >
                    <span>TAX DEDUCTED (3%)</span>
                    <span>{formatCurrency(taxDeducted.toString())}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2px 0",
                      borderTop: "1px solid black",
                      marginTop: "4px",
                    }}
                  >
                    <span>NET AMT AFTER TAX</span>
                    <span>{formatCurrency(netAmtAfterTax.toString())}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0 2px",
                      marginTop: "24px",
                      fontWeight: "bold",
                    }}
                  >
                    <span>TOTAL AMT DUE</span>
                    <span
                      style={{
                        borderBottom: "3px double black",
                        minWidth: "90px",
                        textAlign: "right",
                      }}
                    >
                      {formatCurrency(totalAmtDue.toString())}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })()
      ) : (
        <div></div>
      )}
    </>
  );
}
